import React, { useEffect, useRef } from 'react';
import '../styles/InvestmentGuide.css';
import heroBg from '../assets/images/Investment-Guide-BG.jpg';
import guideImg1 from '../assets/images/investment-guide-success/investment-guide-success-1.png';
import guideImg2 from '../assets/images/investment-guide-success/investment-guide-success-2.png';
import guideImg3 from '../assets/images/investment-guide-success/investment-guide-success-3.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const InvestmentGuideSuccess = () => {
  const stepRefs = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    // Store refs in a variable to avoid the exhaustive-deps warning
    const currentRefs = stepRefs.current;
    
    currentRefs.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      currentRefs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const handleScrollToGuide = () => {
    const guideSection = document.querySelector('.investmentguide-success-video-section');
    if (guideSection) {
      guideSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="investment-guide-page">
      {/* Hero Section */}
      <div
        className="investmentguide-hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="investmentguide-hero-overlay"></div>
        <div className="investmentguide-hero-content">
          <h1 className="investmentguide-hero-title">Thank You For Your Submission!</h1>
          <button
            className="down-arrow-btn"
            aria-label="Scroll to Dubai's Investment Guide"
            onClick={handleScrollToGuide}
            style={{ background: 'none', border: 'none', marginTop: '32px', cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={faChevronDown} size="2x" style={{ color: '#fff' }} />
          </button>
        </div>
      </div>

      {/* Video Section */}
      <section className="investmentguide-success-video-section">
        <p>
          Dubai's Investment Guide<br />
          <span>A Message From Our Managing Director | Sadeq Abbass</span>
        </p>
        <div className="investmentguide-success-video-container">
          <div className="investmentguide-success-video-inner">
              <iframe 
                src="https://drive.google.com/file/d/1B7NdK1GmZWl_rg7hlcDlEluXWpp1VGWr/preview" 
                width="100%" 
                height="480" 
                allow="autoplay"
                title="Dubai Investment Guide Video"
              ></iframe>
          </div>
        </div>
        <div className="become-member-btn-wrapper">
          <button className="community-btn-secondary" onClick={() => navigate('/membership')}>Become A Member</button>
        </div>
      </section>

      {/* Process Section */}
      <section className="investmentguide-success-process">
        <div className="process-title">The Process</div>
        <div className="process-list">
          <div className="process-row">
            <div className="process-illustration">
              <img src={guideImg1} alt="Become A Member Illustration" />
            </div>
            <div className="process-steps-group">
              <div className="process-step">
                <div className="process-step-title">Become A Member</div>
                <div className="process-step-desc">Obtain fully refundable membership</div>
              </div>
              <div className="process-step">
                <div className="process-step-title">1:1 Property Consultation</div>
                <div className="process-step-desc">We learn your requirements in detail</div>
              </div>
              <div className="process-step">
                <div className="process-step-title">Property Strategy Session</div>
                <div className="process-step-desc">We advise on the best tailored strategy for your needs</div>
              </div>
            </div>
          </div>
          <div className="process-row">
            <div className="process-illustration">
              <img src={guideImg2} alt="Research & Analysis Illustration" />
            </div>
            <div className="process-steps-group">
              <div className="process-step">
                <div className="process-step-title">Research & Analysis</div>
                <div className="process-step-desc">We work with our research team to identify the most suitable property for your needs</div>
              </div>
              <div className="process-step">
                <div className="process-step-title">Property Presentation</div>
                <div className="process-step-desc">We present your perfect property to you along with supporting collateral to showcase why</div>
              </div>
            </div>
          </div>
          <div className="process-row">
            <div className="process-illustration">
              <img src={guideImg3} alt="Negotiation Illustration" />
            </div>
            <div className="process-steps-group">
              <div className="process-step">
                <div className="process-step-title">Negotiation</div>
                <div className="process-step-desc">We work with the developer to secure the best deal for you on the property</div>
              </div>
              <div className="process-step">
                <div className="process-step-title">Expression Of Interest</div>
                <div className="process-step-desc">We do an Expression of Interest on the property and facilitate until closure and completion</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="investmentguide-success-community-section">
        <h2 className="community-title">Join Our Community</h2>
        <p className="community-desc">Get Access To Exclusive Benefits And Resources.</p>
        <div className="community-btn-group">
          <a className="community-btn" href="/contact">Book A Consultation</a>
          <a className="community-btn-secondary" href="/membership">Become A Member</a>
        </div>
      </section>
    </div>
  );
};

export default InvestmentGuideSuccess; 